import { Flat, ValueOf } from '.';

export const endPoints = {
  // #1
  listSchools: {
    name: '学校一覧',
    endPoint: '/listSchools',
  },

  // #2
  savePublishDate: {
    name: '公開基幹登録',
    endPoint: '/savePublishDate',
  },
  // #3
  forcedPublishDisable: {
    name: '強制非公開',
    endPoint: '/forcedPublishDisable',
  },
  // #4
  listStatuses: {
    name: '対応状況',
    endPoint: '/listStatuses',
  },

  // #5
  resetPublish: {
    name: '公開情報リセット',
    endPoint: '/resetPublish',
  },
  // #6
  getOfficialDocument: {
    name: '周知文書取得',
    endPoint: '/getOfficialDocument',
  },
  // #7
  saveOfficialDocument: {
    name: '周知文書登録',
    endPoint: '/saveOfficialDocument',
  },
  // #8
  savePassword: {
    name: 'パスワード変更',
    endPoint: '/savePassword',
  },
  // #9
  login: {
    name: 'ログイン処理',
    endPoint: '/login',
  },
  // #10
  getUserInfo: {
    name: 'ユーザー取得',
    endPoint: '/getUserInfo',
  },
  // #11
  getResultPublicationDocument: {
    name: '合格発表ファイル取得',
    endPoint: '/getResultPublicationDocument',
  },
  // #12
  saveResultPublicationDocument: {
    name: '合格発表ファイル登録',
    endPoint: '/saveResultPublicationDocument',
  },
  // #13
  downloadOfficialDocument: {
    name: '周知文書ダウンロード',
    endPoint: '/downloadOfficialDocument',
  },
  // #14
  downloadStatusesList: {
    name: '対応状況ダウンロード',
    endPoint: '/downloadStatusesList',
  },
  // #15
  listAdminSchools: {
    name: '管理者一覧',
    endPoint: '/listAdminSchools',
  },
  // #16
  changeEnabled: {
    name: '有効無効切替',
    endPoint: '/changeEnabled',
  },
  // #17
  getParameters: {
    name: 'パラメータ情報取得',
    endPoint: '/getParameters',
  },
  // #18
  downloadOfficialDocumentTemplate: {
    name: '周知文書ダウンロード',
    endPoint: '/downloadOfficialDocumentTemplate',
  },
  // #19
  downloadResultPublicationDocument: {
    name: '合格発表ファイルダウンロード',
    endPoint: '/downloadResultPublicationDocument',
  },
  // #20
  cancellationPrivate: {
    name: '非公開の解除',
    endPoint: '/cancellationPrivate',
  },
  // #21
  downloadOfficialDocumentForAdmin: {
    name: '対応状況一覧用周知文書ダウンロード',
    endPoint: '/downloadOfficialDocumentForAdmin',
  },
  // #22
  downloadResultPublicationDocumentForAdmin: {
    name: '対応状況一覧用合格発表ファイルダウンロード',
    endPoint: '/downloadResultPublicationDocumentForAdmin',
  },
} as const;

export type EndPoint = ValueOf<Flat<typeof endPoints>, 'endPoint'>;

type AllParams = {
  listSchools: {
    page: number;
    itemsPerPage: number;
    sortKey:
      | 'organization_name'
      | 'rehearsal_startdate_at'
      | 'production_startdate_at'
      | 'status';
  };
  savePublishDate: {
    organization_ids: string;
    publish_types: number;
    startdate_at: string;
    enddate_at: string;
  };
  forcedPublishDisable: {
    organization_ids: string;
    forced_disabled_text: string;
  };
  listStatuses: {
    page: number;
    itemsPerPage: number;
    sortKey:
      | 'organization_name'
      | 'organization_type_id'
      | 'rehearsal_startdate_at'
      | 'production_startdate_at'
      | 'status';
  };
  resetPublish: {
    organization_type_ids: string;
    publish_types: string;
  };
  getOfficialDocument: {
    publish_type: number;
  };
  saveOfficialDocument: FormData;
  savePassword: {
    organization_ids: string;
    password: string;
  };
  login: {
    password: string;
  };
  getResultPublicationDocument: {
    publish_type: number;
  };
  saveResultPublicationDocument: FormData;
  listAdminSchools: {
    page: number;
    itemsPerPage: number;
    sortKey: 'organization_name';
    order_by: 'asc' | 'desc';
    organization_name: string;
    is_enabled?: 0 | 1;
  };
  changeEnabled: {
    organization_ids: string;
    is_enabled: 0 | 1;
  };
  cancellationPrivate: {
    organization_ids: string;
  };
  downloadOfficialDocumentForAdmin: {
    organization_ids: string[];
  };
  downloadResultPublicationDocumentForAdmin: {
    publish_types: number;
    organization_ids: string[];
  };
};

export type Params<T extends keyof AllParams> = AllParams[T];
